import { PollUntilSuccessOptions, pollUntilSuccess, restRequest } from 'core/utils/backend-service';
import { JobAsyncProcessRawResponse, JobAsyncProcessResult } from './job-async-processes.type';

export const JOB_ASYNC_PROCESSES_REST_ENDPOINT = 'api/v1/job-async-processes';

export const pollJobAsyncProcess = async <TDetail>(
    jobId: string,
    options?: Omit<PollUntilSuccessOptions<unknown>, 'pollFn'>
): Promise<JobAsyncProcessResult<TDetail>> => {
    const pollFn = async () => {
        let response: JobAsyncProcessRawResponse<TDetail>;

        try {
            response = await restRequest('GET', `${JOB_ASYNC_PROCESSES_REST_ENDPOINT}/${jobId}`, {
                signal: options?.signal,
            }).then((res) => res.json());
        } catch (error) {
            if (error instanceof DOMException && error.name === 'AbortError') {
                throw error;
            }
            return { status: 'error' as const };
        }

        if (response.status === 'PROCESSING') {
            return { status: 'pending' as const };
        }

        if (response.status === 'SUCCESS') {
            return { status: 'success' as const, detailJob: response.detailJob as TDetail };
        }

        return { status: 'error' as const, detailJob: response.detailJob };
    };

    const result = await pollUntilSuccess({ ...options, pollFn });
    return result as JobAsyncProcessResult<TDetail>;
};
